import firebase from '@firebase/app'
import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'

// firebase configuration
var firebaseConfig = {
apiKey: "AIzaSyApu9Cd7p7QYeyioBWgZO-DYyLqKXzDlwo",
authDomain: "datarecord-86988.firebaseapp.com",
databaseURL: "https://datarecord-86988.firebaseio.com",
projectId: "datarecord-86988",
storageBucket: "datarecord-86988.appspot.com",
messagingSenderId: "902100169156",
appId: "1:902100169156:web:32da733b99a44477437491",
measurementId: "G-YZNTD9YHY5"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const db = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.functions();

export { db, auth, functions, firebase };
